import { MembershipStatus } from '@/features/account/services/MembershipPlan/types'
import { fetchAllExperiments } from '@/features/shared/services/Experiments/fetcher'
import { hasShiptEmail } from '@/features/shared/services/Experiments/utils'
import { queryOptions } from '@tanstack/react-query'
import { type StoreParams } from '@/features/shared/utils/dataFetching/storeParams'
import { type User } from '@/features/account/services/User/types'

export const experimentsQueryOptions = ({
  user,
  storeParams,
}: {
  user: User | undefined
  storeParams: StoreParams
}) => {
  const {
    id,
    has_purchased,
    has_placed_first_order,
    has_placed_marketplace_order = false,
  } = user || {}
  return queryOptions({
    queryKey: [
      'Aristotle experiments',
      {
        storeParams,
        has_purchased,
        has_placed_first_order,
        has_placed_marketplace_order,
        has_subscription: user?.subscription?.status === MembershipStatus.active,
        has_shipt_email: hasShiptEmail(user?.email),
        is_exempt: Boolean(user?.exempt),
        plan_id: user?.subscription?.plan?.id,
        user_id: id,
        subscription_type: user?.subscription?.type,
      },
    ] as const,
    queryFn: fetchAllExperiments,
    // we don't want Experiments to refetch during a user session, so that we maintain a consistent user experience during a session
    staleTime: Infinity,
  })
}
